import { useNavigate } from "react-router-dom";
import Modal from "../shared/Modal";
import "./ModalAccountLocked.css";

type ModalModalAccountLockedProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
};

const ModalAccountLocked = ({
  isOpen,
  onClose,
  title,
  message,
}: ModalModalAccountLockedProps) => {
  const navigate = useNavigate();

  if (!isOpen) {
    return null;
  }

  const goToBilling = () => {
    navigate("/billing");
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={true}
        allowClickout={true}>
        <div id="modal-account-locked-confirm">
          <div className="modal-account-locked-confirm-title">{title}</div>

          <div className="modal-account-locked-confirm-content">{message}</div>

          <div className="modal-account-locked-confirm-footer">
            <div className="modal-account-locked-confirm-buttons">
              <button onClick={onClose} className="collections-button-negative">
                Dismiss
              </button>

              <button onClick={goToBilling} className="collections-button">
                Upgrade
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalAccountLocked;
